import React, {useEffect, useRef, useState} from "react";
import {YhBox} from "@/components2/YhBox";
import {Button, Col, message, Row, Tree} from "antd";
import {ISCMShopDetail, shopService} from "@/views/masterDataService/shop/shopService";
import {DataNode} from "antd/lib/tree";
import {createModel} from "hox";
import {FormItemTypeEnum, IYhForm, IYhFormRef} from "@/components2/YhFormBox/Types";
import {YhForm} from "@/components2/YhFormBox";
import useNavModel from "@/model/navModel";
import {useServiceItemsModel} from "@/views/masterDataService/serviceItems/serviceItemsModel";
import {
    IServiceItemsDetail,
    IServiceItemsShopPriceParams
} from "@/views/masterDataService/serviceItems/serviceItemsTypes";
import {serviceItemsService} from "@/views/masterDataService/serviceItems/serviceItemsService";
import {getFormValidatorErrText} from "@/utils/utils";
import {globalPrompt} from "@/components/YhMessage";

import {Typography} from 'antd';

const {Title} = Typography;


/**
 * 服务项目和门店关联
 * @constructor
 */
const ServiceItemShopDetails = () => {
    const {selectedRow} = useServiceItemsModel();
    const {currentRecord, setCurrentRecord} = useShopDetailModel();
    useEffect(() => {
        if (selectedRow) {
            setCurrentRecord(selectedRow[0])
        }
    }, [])

    const item = () => {
        if (currentRecord) {
            return <>
                <SearchForm/>
                <div className="flex">
                    <ShopTree/>
                    <ShopForm/>
                </div>
            </>
        }
        return <div> 没有读取到服务项目 </div>
    }
    return item()
}
export default ServiceItemShopDetails;

interface ShopDataNode extends DataNode {
    record?: ISCMShopDetail

}


const useShopDetailModel = createModel(function () {
    const [treeRowKey, setTreeRowKey] = useState<React.Key[]>([])
    const [treeSelectedNode, setTreeSelectedNode] = useState<ShopDataNode>()
    const [treeData, setTreeData] = useState<ShopDataNode[]>([])
    const [formData, setFormData] = useState<IServiceItemsShopPriceParams | null>(null)
    const [currentRecord, setCurrentRecord] = useState<IServiceItemsDetail | null>(null);
    const formRef = useRef<IYhFormRef>()


    const initTreeData = async () => {//门店管理
        const params = {page: {pageSize: 10000, pageNum: 1}};
        const {retData} = await shopService.page(params)
        const {records, ...pg} = retData
        const data: ShopDataNode[] = records.map(i => ({
            key: i.code,
            title: `${i.branch}-${i.name}`,
            children: [],
            branch: i.branch,
            record: i
        })).sort((a, b) => a.branch.length - b.branch.length);
        setTreeData(data)
    }

    const resetFormData0 = async (treeSelectedNode: ShopDataNode) => {
        console.log(1221)
        debugger
        await formRef.current?.resetFields();
        const shopCode = treeSelectedNode?.record?.code
        const shopName = treeSelectedNode?.record?.name
        const shopId = treeSelectedNode?.record?.id
        const itemCode = currentRecord?.code;
        const itemName = currentRecord?.name;
        let workHours = currentRecord?.workHours as number;
        let price = currentRecord?.price as number;
        let itemAmount = workHours * price;
        let enable: number | undefined = 1;
        let note = "";
        if (shopCode && itemCode) {
            const {retData: dbItem} = await serviceItemsService.shopOne(shopCode, itemCode)
            if (dbItem) {
                workHours = dbItem.itemWorkHours as number
                price = dbItem.workHoursPrice as number
                itemAmount = dbItem.itemAmount as number
                note = dbItem.note ? dbItem.note : ""
                enable = dbItem.enable
            }
        }
        const shopInfo = treeSelectedNode?.title as string;
        await setFormData({
            sourceApp: "mdm",
            code: shopCode,
            name: shopName,
            shopId: shopId,
            itemCode: itemCode,
            itemName: itemName,
            itemWorkHours: workHours,
            workHoursPrice: price,
            itemAmount: itemAmount,
            enable: enable,
            note: note,
            shopInfo: shopInfo
        })
    }


    const resetFormData = async () => {
        if (treeSelectedNode) {
            resetFormData0(treeSelectedNode);
        }
    }


    const treeOnSelect = async (selectedKeys: React.Key[], info: any) => {
        const selectedNode: ShopDataNode = info.selectedNodes[0];
        await setTreeRowKey(selectedKeys)
        await setTreeSelectedNode(selectedNode)
        await resetFormData0(selectedNode)
    };


    const formOnFinish = async () => {
        if (formData) {
            formData.enable = formData.enable ? 1 : 0;
            const {retMsg} = await serviceItemsService.shopInsertOrUpDate(formData);
            await globalPrompt("message", {type: "success", text: retMsg});
            await resetFormData()
        }

    }

    return {
        initTreeData,
        treeRowKey,
        setTreeRowKey,
        treeSelectedNode,
        setTreeSelectedNode,
        treeData,
        setTreeData,
        formData,
        setFormData,
        currentRecord,
        setCurrentRecord,
        resetFormData,
        treeOnSelect,
        formRef,
        formOnFinish

    }
})


const SearchForm = () => {
    return <></>
};

const ShopTree = () => {
    const {
        treeRowKey,
        treeData,
        initTreeData,
        treeOnSelect
    } = useShopDetailModel();

    useEffect(() => {
        initTreeData()
    }, [])


    const onCheck = () => {
    };
    return <YhBox title="门店目录" width="500px">
        <Tree
            className="p-15"
            treeData={treeData}
            selectedKeys={treeRowKey}
            onSelect={treeOnSelect}
            onCheck={onCheck}
        />
    </YhBox>

};
const ShopForm = () => {
    const {closeNav} = useNavModel()
    const {
        formData,
        setFormData,
        // 被选中的服务项目
        currentRecord,
        resetFormData,
        formRef,
        formOnFinish,
    } = useShopDetailModel();


    const item = [
        {
            type: FormItemTypeEnum.Input,
            fieldLabel: "门店",
            fieldName: "shopInfo",
            disable: true,
            span: 12,
            rules: [{required: true, message: '请先选择门店'}]
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "工时",
            fieldName: "itemWorkHours",
            span: 12,
            rules: [{required: true, message: '该项为必填项'}]
        }
        , {
            type: FormItemTypeEnum.Input,
            fieldLabel: "单价",
            fieldName: "workHoursPrice",
            span: 12,
            rules: [{required: true, message: '该项为必填项'}]
        }
        , {
            type: FormItemTypeEnum.Input,
            fieldLabel: "总价",
            fieldName: "itemAmount",
            span: 12,
            disable: true
        }
        , {
            type: FormItemTypeEnum.Input,
            fieldLabel: "备注",
            fieldName: "note",
            span: 12,
        }, {
            type: FormItemTypeEnum.Switch,
            fieldLabel: "状态",
            fieldName: "enable",
            valuePropName: "checked",
            span: 12,
        }
    ]


    const onChange = (value: any) => {
        const newData = {...formData, ...value}
        newData.itemAmount = newData?.itemWorkHours * newData?.workHoursPrice;
        setFormData({...newData})
    }

    const formConfig: IYhForm = {
        formRef: formRef,
        labelCol: {span: 6},
        disabled: false,
        formValues: formData,
        items: item,
        onFinish: formOnFinish,
        onChange: onChange
    }
    const onOk = () => {
        formRef.current?.inst().submit()
    }
    const reset = () => {
        resetFormData().catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const attr = () => {
        let itemAttr = currentRecord?.itemAttr;
        let str = "";
        if ("import" === itemAttr) {
            str = "进口";
        }
        if ("domestic" === itemAttr) {
            str = "国产";
        }
        return str
    }

    return <YhBox title="" width="100vw">


        {currentRecord &&
            <div style={{marginLeft: "150px", marginBottom: "150px"}}>
                <Title>标准价格</Title>
                <Row>
                    <Col span={8}>项目名称： {currentRecord.name} </Col>
                    <Col span={8}>项目编码： {currentRecord.code} </Col>
                    <Col span={8}>项目属性： {attr()}</Col>
                </Row>
                <Row>
                    <Col span={8}>项目工时： {currentRecord.workHours} </Col>
                    <Col span={8}>项目单价： {currentRecord.price} </Col>
                    <Col span={8}>项目总价： {currentRecord.workHours * currentRecord.price} </Col>
                </Row>

            </div>

        }
        <div style={{marginLeft: "150px"}}>
            <Title>各门店价格</Title>
        </div>
        <YhForm {...formConfig} />
        <div style={{marginLeft: "150px"}}>


            <Button onClick={onOk} shape="round" type="link">确认</Button>
            <Button onClick={reset} shape="round" type="link">重置</Button>
            <Button onClick={() => {
                closeNav("2-13-4")
            }} shape="round">取消</Button>
        </div>
    </YhBox>
};
